<template>
  <div>
    <Breadtabsheader />
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="订单编号" prop="sapCode" style="width: 50%">
                <el-input v-model="formInline.sapCode" placeholder="多订单号逗号隔开"></el-input>
              </el-form-item>
              <el-form-item label="合同编码" prop="contractNo">
                <el-input v-model="formInline.contractNo" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="售达方名称或编码" prop="soldToName">
                <el-input v-model="formInline.soldToName" placeholder="请输入"></el-input>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="套餐编码" prop="packageOrderCode">
                <el-input v-model="formInline.packageOrderCode" clearable placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="产品编码" prop="materialCode">
                <el-input v-model="formInline.materialCode" clearable placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="纸质发票号" prop="bktxt">
                <el-input v-model="formInline.bktxt" clearable placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="订单创建人" prop="cuname">
                <el-input v-model="formInline.cuname" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="创建时间" prop="cdatebegin" style="width: 50%;">
                <el-date-picker v-model="formInline.cdatebegin" clearable type="date" value-format="yyyy-MM-dd">
                </el-date-picker>
                <span class="w-time-to">至</span>
                <el-date-picker v-model="formInline.cdateend" clearable type="date" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="合同打印" prop="isShhm">
                <el-select v-model="formInline.isShhm" placeholder="请选择" clearable>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发货通知打印" prop="isDraft">
                <el-select v-model="formInline.isDraft" placeholder="请选择" clearable>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="发票打印" prop="isJj">
                <el-select v-model="formInline.isJj" placeholder="请选择" clearable>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机编号" prop="machineNumber">
                <el-input v-model="formInline.machineNumber" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="直发/库发" prop="isDraft">
                <el-select v-model="formInline.zhifakufa" placeholder="请选择" clearable>
                  <el-option label="直发" value="1"></el-option>
                  <el-option label="库发" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态" prop="isDraft">
                <el-select v-model="formInline.isDel" placeholder="请选择" clearable>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="删除" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="right-btn">
                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                <el-button @click="resetData" class="h-btn h-formBtn h-bgwhite">重置</el-button>
              </el-form-item>
            </div>
            <!-- <div class="h-thirdColumn w-newColumn">

            </div> -->
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30">
        <el-table ref="ddtable" @selection-change="handleSelectionChange" :data="tableData" :span-method="objectSpanMethod" stripe style="width: 100%" :border="true" max-height="450">
          <el-table-column type="selection" width="40" label="全选">
          </el-table-column>
          <el-table-column fixed type="index" label="#" width="40">
          </el-table-column>
          <el-table-column fixed prop="contractNo" label="合同编码" :show-overflow-tooltip="true" width="120">
          </el-table-column>
          <el-table-column prop="sapCode" label="订单编号" min-width="110" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="status" label="订单状态" :show-overflow-tooltip="true" width="110">
            <template scope="scope">
              {{scope.row.status|dictname('order_status')}}
            </template>
          </el-table-column>
          <el-table-column prop="packageOrderCode" label="套餐编码" min-width="110" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="packageName" label="套餐名称" :show-overflow-tooltip="true" width="100">
          </el-table-column>
          <el-table-column prop="soldToName" label="售达方名称" :show-overflow-tooltip="true" width="200">
          </el-table-column>
          <el-table-column prop="soldToCode" label="售达方编码" :show-overflow-tooltip="true" width="200">
          </el-table-column>
          <el-table-column label="销售省区" class="h-elformWrap-2" prop="salesregion">
            <template slot-scope="scope">
              {{scope.row.salesregion | dictname('YlSalesArea_chanpin')}}
            </template>
          </el-table-column>
          <el-table-column label="收货地址" class="h-elformWrap-2" prop="toAddress" width="160" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="contactName" label="收货人" min-width="110" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="收货人电话" class="h-elformWrap-2" prop="firsttelephone" width="110" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="goodsName" label="货物名称" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="yidishpyj" label="客户型号" width="110">
          </el-table-column>
          <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="proNumber" label="订单数量" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="finalPrice" label="单价" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="totalprice" label="总价" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="totalGscodePrice" label="总金额" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="claimWrbtrs" label="已认领金额" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="totalClaimWrbtrs" label="已认领总金额" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="note1" label="备注" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="cuname" label="订单创建人" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="isShhm" label="合同打印" :show-overflow-tooltip="true" width="110">
            <template slot-scope="scope">
              <span>{{scope.row.isShhm==1?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="isDraft" label="发货通知打印" :show-overflow-tooltip="true" width="110">
            <template slot-scope="scope">
              <span>{{scope.row.isDraft==1?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="isJj" label="发票打印" :show-overflow-tooltip="true" width="110">
            <template slot-scope="scope">
              <span>{{scope.row.isJj==1?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cdate" label="订单创建时间" :formatter="formatDatecc" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="fhdate" label="发货时间" :formatter="formatDatecc" :show-overflow-tooltip="true" width="110">
          </el-table-column>
          <el-table-column prop="bktxt" label="纸质发票号" :show-overflow-tooltip="true" width="150">
          </el-table-column>
          <el-table-column prop="machineNumber" label="机编号" :show-overflow-tooltip="true" width="150"></el-table-column>

          <el-table-column prop="zhifakufa" label="直发/库发" :show-overflow-tooltip="true" width="150">
            <template slot-scope="scope">
              <span>{{scope.row.zhifakufa==1?'直发':'库发'}}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" fixed="right" min-width="400">
            <template slot-scope="scope">
              <div style="text-align: left;">
                <el-button type="text" size="small" class="h-tableLink h-btn" @click="lookPdf(scope.row)">
                  销售合同
                </el-button>
                <el-button size="small" class="h-tableLink h-btn" v-if="scope.row.serialNumber != null && scope.row.serialNumber != ''" @click="getInvoiceCode(scope.row.serialNumber,scope.row.contractNo)">发票下载
                </el-button>
                <el-button
                    v-auth="'createxiaoshoucontract'"
                    v-if="scope.row.totalClaimWrbtrs < scope.row.totalGscodePrice"
                    type="text"
                    size="small" class="h-tableLink h-btn"
                    @click="huikuan(scope.row)">
                  回款认领
                </el-button>
                <el-button
                    v-auth="'createxiaoshoucontract'"
                    type="text"
                    size="small" class="h-tableLink h-btn"
                    @click="claimRecord(scope.row)">
                  认领记录
                </el-button>
                <el-button
                    v-auth="'createxiaoshoucontract'"
                    type="text"
                    size="small" class="h-tableLink h-btn"
                    @click="pushSapData(scope.row)">
                  推送SAP
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel()">批量导出
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-fahuo" @click="sendAll">
              批量安排发货
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-auth="'createxiaoshoucontract'" @click="createInvoice">发货通知单
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-auth="'createxiaoshoucontract'" @click="createInvoicepdf">发货通知单pdf
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-auth="'createxiaoshoucontract'" @click="mergeFile">合并合同
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="formInline" @query="query" />
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="lookPdfflag" width="100%" top="0">
        <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
      </el-dialog>
      <el-dialog :close-on-click-modal="false"  :visible.sync="visible">
        <div>
          <div  style="margin-bottom: 1px;">
            <el-form :inline="true" :model="modelUserCode">
              <el-row>
                <el-form-item>
                  <span style="color: red">注：请先勾选凭证编号并填写认领金额后再点击确认认领</span>
                  <el-button type="primary" style="margin-left: 200px" @click="selectUser">确认</el-button>
                </el-form-item>
              </el-row>
            </el-form>
          </div>
          <el-table
              max-height="400px"
              size="mini"
              :data="ttdata"
              border
              tooltip-effect="dark"
              style="width: 100%">
<!--            <el-table-column
                type="selection"
                fixed
                width="55">
            </el-table-column>-->
            <el-table-column
                fixed
                label="订单金额"
                width="100">
              {{null != sapCodeCopy ? sapCodeCopy.totalprice : ""}}
            </el-table-column>
            <el-table-column
                prop="wrbtr"
                label="回款金额">
            </el-table-column>
            <el-table-column
                prop="surplusWrbtr"
                label="剩余待认领金额">
            </el-table-column>
            <el-table-column
                prop="claimCurrent"
                label="认领金额"
                width="100">
              <template slot-scope="scope">
                <el-input :disabled="0 == scope.row.surplusWrbtr ? true:false" v-model="scope.row.claimCurrent" @blur="inputBlur(scope.row)"></el-input>
              </template>
            </el-table-column>
<!--            <el-table-column
                prop="blart"
                label="凭证类型"
                width="50">
            </el-table-column>-->
<!--            <el-table-column
                prop="bukrs"
                label="公司代码">
            </el-table-column>-->
<!--            <el-table-column
                prop="waers"
                label="货币类型"
                :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.waers | dictname('YLCurrency') }}
                </div>
              </template>
            </el-table-column>-->
            <el-table-column
                prop="budat"
                label="凭证过账日期"
                :formatter="formatDatecc"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="gjahr"
                label="会计年度">
            </el-table-column>
          </el-table>
          <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
            <paginationmin :page="modelUserCode" @query="selectHuikuan"/>
          </div>
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false"  :visible.sync="dataCopyLine">
              <el-table
                  :data="tableDataCopy"
                  :border="true"
                  max-height="560"
                  style="width: 100%">
                <el-table-column prop="sapCode" label="订单编号" width="100px"></el-table-column>
                <el-table-column prop="goodsName" label="货物名称" :show-overflow-tooltip="true" width="110"></el-table-column>
                <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="110"></el-table-column>
                <el-table-column prop="proNumber" label="订单数量" width="60px"></el-table-column>
                <el-table-column prop="finalPrice" label="单价" width="60px"></el-table-column>
                <el-table-column prop="totalprice" label="总价" width="90px"></el-table-column>
                <el-table-column prop="claimWrbtrs" label="认领金额" width="90px"></el-table-column>
                <el-table-column prop="" label="操作" width="90px">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.claimWrbtrs < scope.row.totalprice" type="text" size="small" class="h-tableLink h-btn" @click="saphuikuan(scope.row)">认领</el-button>
                  </template>
                </el-table-column>
              </el-table>
        <div class="h-tableB h-mrt30" style="margin-left: 300px">
          <div>
            <el-button class="h-btn h-formBtn h-bgblueQ" @click="submitResult()">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false"  :visible.sync="claimRecordVisible">
        <div class="h-rowIn" >
          <div class="h-rowBox">
            <div class="h-rowCon">
              <el-table
                  :data="claimRecordData"
                  :border="true"
                  max-height="560"
                  style="width: 100%">
                <el-table-column
                    label="序号"
                    type="index"
                    fixed
                    width="50">
                </el-table-column>
                <el-table-column prop="sapCode" label="订单编号" width="150px"></el-table-column>
                <el-table-column prop="wrbtr" label="回款总金额" width="100px"></el-table-column>
                <el-table-column prop="claimWrbtr" label="已认领金额" width="100px"></el-table-column>
                <el-table-column prop="surplusWrbtr" label="剩余金额" width="100px"></el-table-column>
                <el-table-column prop="belnr" label="凭证编号" width="150px"></el-table-column>
                <el-table-column prop="blart" label="凭证类型" width="90px"></el-table-column>
                <el-table-column prop="bukrs" label="公司代码" width="90px"></el-table-column>
                <el-table-column prop="waers" label="货币类型" width="90px"></el-table-column>
                <el-table-column prop="budat" label="凭证过账日期" width="90px" :formatter="formatDatecc"></el-table-column>
                <el-table-column prop="gjahr" label="会计年度" width="90px"></el-table-column>

                <el-table-column prop="claimUserName" label="认领人" width="110px"></el-table-column>
                <el-table-column prop="claimDate" label="认领时间" width="140px" ></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ss from "@/api/SystemService";
import updownfile from "@/utils/updownfile";
import {number} from "echarts/lib/export";
export default {
  components: { updownfile },
  data () {
    return {
      fahuoFlag : true,
      formInline: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        contractNo: null,
        sapCode: null,
        soldToName: null,
        materialCode: null,
        packageOrderCode: null,
        bktxt: null,
        cuname: null,
        cdatebegin: null,
        cdateend: null,
        isShhm: null,
        isJj: null,
        machineNumber:null,
        isDraft: null,
        isDel:"0"
      },
      pdfUrl: null,
      lookPdfflag: false,
      spanArr: [],
      multipleSelection: [],
      tableData: [],
      tableDataCopy: [],
      sapCodeCopy:null,
      ttdata:[],
      claimRecordData:[],
      resultData:[],
      visible:false,
      claimRecordVisible:false,
      dataCopyLine:false,
      changeRow:null,
      modelUserCode:{
        receUsercode : null,
        belnr : null,
        bukrs : null,
        contractNo : null,
        pageSize : 10,
        pageNo : 1,
        total : 0,
      },
    }
  },
  created () {
    this.query();

  },
  methods: {
    //发票下载
    getInvoiceCode (number, contractId) {
      ss.OrderMainService.getInvoiceObtainYx(number, contractId).then(rd => {
        console.log("rd", rd.msg.invoiceUrl)
        if (rd.f && rd.msg.invoiceUrl != null && rd.msg.invoiceUrl != '') {

          //window.location.href = rd.msg.invoiceUrl;
          window.open(rd.msg.invoiceUrl, "_blank");
          this.query();
        } else {
          this.$msg.msge("未查询到发票信息!");
          return false;
        }
      });
    },
    query () {
      ss.contractService.contractyxListPage(this.formInline).then(rd => {
        this.formInline.total = rd.total;
        this.tableData = rd.records;
        this.getSpanArr();
      });
    },
    resetData () {
      this.formInline.contractNo = null;
      this.formInline.sapCode = null;
      this.formInline.soldToName = null;
      this.formInline.materialCode = null;
      this.formInline.packageOrderCode = null;
      this.formInline.bktxt = null;
      this.formInline.cuname = null;
      this.formInline.cdateend = null;
      this.formInline.cdatebegin = null;
      this.formInline.isShhm = null;
      this.formInline.isJj = null;
      this.formInline.machineNumber = null;
      this.formInline.isDraft = null;
      this.query();
    },
    //在线查看pdf测试地址
    lookPdf (row) {
      console.log(row)
      let arr = [];
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].contractNo == row.contractNo) {
          arr.push(this.tableData[i].sapCode)
        }
      }
      ss.OrderMainService.supplementlater(arr).then(rd => {
        const blob = new Blob([rd], { type: 'application/pdf' })
        this.pdfUrl = URL.createObjectURL(blob)
        this.lookPdfflag = true;
        this.query();
      })
    },
    huikuan(row){
      this.tableDataCopy = [];
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].contractNo == row.contractNo){
          this.tableDataCopy.push(this.tableData[i])
        }
      }
      this.modelUserCode.receUsercode = row.soldToCode;
      this.modelUserCode.bukrs = row.gscode;
      this.modelUserCode.contractNo = row.contractNo;
      this.dataCopyLine = true;
    },
    /**
     * 点击认领按钮
     * @param row
     */
    saphuikuan(row){
      this.sapCodeCopy = null;
      for (let i = 0; i < this.tableDataCopy.length; i++) {
        if (this.tableDataCopy[i].sapCode == row.sapCode){
          this.sapCodeCopy = this.tableDataCopy[i];
          break;
        }
      }
      ss.OrderMainService.selectClaimYuanxiPage(this.modelUserCode).then(res => {
        this.modelUserCode.total = res.total;
        this.ttdata = res.records;
        if (this.ttdata){
          for (let g = 0; g < this.tableDataCopy.length; g++) {
            if (this.tableDataCopy[g].recordList){
              for (let i = 0; i < this.tableDataCopy[g].recordList.length; i++) {
                for (let j = 0; j < this.ttdata.length; j++) {
                  if (this.ttdata[j].belnr == this.tableDataCopy[g].recordList[i].belnr){
                    let a = Number(this.ttdata[j].surplusWrbtr);
                    let b = Number(this.tableDataCopy[g].recordList[i].claimCurrent);
                    let resut = a - b;
                    this.ttdata[j].surplusWrbtr = resut;
                  }
                }
              }
            }
          }
        }
      }).catch((error) => {
        this.$alert("获取信息失败，请联系系统管理员", '提示', {
          confirmButtonText: '确定',
          type:'error',
        });
      });
      this.visible = true;
    },
    claimRecord(row){
      let a = {contractNo : row.contractNo};
      ss.OrderMainService.selectList(a).then(res => {
        this.claimRecordData = res;
        this.claimRecordVisible = true;
      }).catch((error) => {
        this.$alert("获取信息失败，请联系系统管理员", '提示', {
          confirmButtonText: '确定',
          type:'error',
        });
      });
    },
    selectHuikuan(){
      ss.OrderMainService.selectClaimYuanxiPage(this.modelUserCode).then(res => {
        this.ttdata = res.records;
        this.modelUserCode.total = res.total;
      }).catch((error) => {
        this.$alert("获取信息失败，请联系系统管理员", '提示', {
          confirmButtonText: '确定',
          type:'error',
        });
      });
    },
    /*handleSelectionChangehuikuan(resultData){
      this.resultData = resultData;
    },*/
    /**
     * 回款认领弹框确认认领按钮
     */
    selectUser(){
      for (let i = 0; i < this.ttdata.length; i++) {
        if (null != this.ttdata[i].claimCurrent && '' != this.ttdata[i].claimCurrent && undefined != this.ttdata[i].claimCurrent && 0 != this.ttdata[i].claimCurrent){
          this.resultData.push(this.ttdata[i])
          this.ttdata[i].surplusWrbtr = this.ttdata[i].surplusWrbtr -this.ttdata[i].claimCurrent;
          let dataOne = this.ttdata[i];
          for (let g = 0; g < this.tableDataCopy.length; g++) {
            if (this.tableDataCopy[g].sapCode == this.sapCodeCopy.sapCode){
              if (this.tableDataCopy[g].recordList){
                this.tableDataCopy[g].recordList.push(dataOne);
              }else {
                this.tableDataCopy[g].recordList = [];
                this.tableDataCopy[g].recordList.push(dataOne);
              }
              let a = Number(this.tableDataCopy[g].claimWrbtrs);
              let b = a + Number(dataOne.claimCurrent);
              this.tableDataCopy[g].claimWrbtrs = b;
              break;
            }
          }
        }
      }
      console.log(this.resultData)
      if (this.resultData.length > 0) {
        /*//查询的数据
        for (let j = 0; j < this.resultData.length; j++) {
          //选择的回款数据
          for (let i = 0; i < this.ttdata.length; i++) {
            if (this.ttdata[i].belnr == this.resultData[j].belnr){
              this.ttdata[i].surplusWrbtr = this.ttdata[i].surplusWrbtr - this.resultData[j].claimCurrent;
              let dataOne = this.ttdata[i];
              for (let g = 0; g < this.tableDataCopy.length; g++) {
                if (this.tableDataCopy[g].sapCode == this.sapCodeCopy.sapCode){
                  if (this.tableDataCopy[g].recordList){
                    this.tableDataCopy[g].recordList.push(dataOne);
                  }else {
                    this.tableDataCopy[g].recordList = [];
                    this.tableDataCopy[g].recordList.push(dataOne);
                  }
                  let a = Number(this.tableDataCopy[g].claimWrbtrs);
                  let b = a + Number(dataOne.claimCurrent);
                  this.tableDataCopy[g].claimWrbtrs = b;
                  break;
                }
              }
              break;
            }
          }
        }*/
        this.visible = false;
      }else {
        this.$alert("请输入需要认领的金额", '提示', {
          confirmButtonText: '确定',
          type:'warning',
        });
      }
    },
    /**
     * 提交订单认领金额信息
     */
    submitResult(){
      for (let i = 0; i < this.tableDataCopy.length; i++) {
        if (this.tableDataCopy[i].recordList){
          //认领金额
          let a = 0;
          for (let j = 0; j < this.tableDataCopy[i].recordList.length; j++) {
            a +=  Number(this.tableDataCopy[i].recordList[j].claimCurrent)
          }
          if (Number(a) > Number(this.tableDataCopy[i].totalprice)){
            this.$alert(this.tableDataCopy[i].sapCode + "认领金额大于订单金额，请调整！", '提示', {
              confirmButtonText: '确定',
              type:'error',
            });
            return;
          }
        }
      }
      //校验套餐订单是否展示提示语 一个套餐订单号回款认领完毕，其他套餐订单未认领或认领金额小于订单总金额 提示
      //1、获取选中的套餐订单
      let arrList = this.tableDataCopy.filter(item => null != item.packageOrderCode && '' != item.packageOrderCode && undefined != item.packageOrderCode);
      ss.OrderMainService.saveClaimRecordYuanxi(this.tableDataCopy,this.modelUserCode.contractNo).then(res => {
          if (res.f){
            this.query();
            this.dataCopyLine = false;
            this.modelUserCode.receUsercode = null;
            this.modelUserCode.belnr = null;
            this.modelUserCode.bukrs = null;
            this.modelUserCode.contractNo = null;
            this.modelUserCode.pageNo = 1;
            this.modelUserCode.pageSize = 10;
            this.modelUserCode.total = 0;
            this.$alert("保存成功", '提示', {
              confirmButtonText: '确定',
              type:'success',
            });
          }
        }).catch((error) => {
          this.$alert("领取失败，请联系系统管理员", '提示', {
            confirmButtonText: '确定',
            type:'error',
          });
        });
    },
    pushSapData(row){
      console.log(this.multipleSelection)
      if (this.multipleSelection.length == 0){
        this.$alert("请勾选产品订单", '提示', {
          confirmButtonText: '确定',
          type:'error',
        });
        return;
      }
      ss.OrderMainService.changeClaimAmount(this.multipleSelection).then(res => {
        console.log(res.f)
        if (res.f){
          if (res.msg != '操作成功'){
            this.$alert(res.msg + "是否推送SAP", "提示", {
              showCancelButton: true,
              confirmButtonText: "是",
              cancelButtonText: "否",
              callback: (action) => {
                //点击确定
                if (action === "confirm") {
                  console.log("确认提交")
                  ss.OrderMainService.pushSapData(this.multipleSelection).then(response => {
                    if (response.f){
                      this.query();
                      this.$alert("推送成功", '提示', {
                        confirmButtonText: '确定',
                        type:'success',
                      });
                    }
                  })
                }else {
                  //继续走流程
                  console.log("取消提交")
                }
              }
            });
          }else {
            ss.OrderMainService.pushSapData(this.multipleSelection).then(response => {
              if (response.f){
                this.query();
                this.$alert("推送成功", '提示', {
                  confirmButtonText: '确定',
                  type:'success',
                });
              }
            })
          }
        }else {
          this.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            type:'error',
          });
        }
      }).catch((error) => {
        this.$alert("领取失败，请联系系统管理员", '提示', {
          confirmButtonText: '确定',
          type:'error',
        });
      });

    },
    /**
     * 校验认领金额
     * @param row
     */
    inputBlur(row){
      const regex = /^\d+(\.\d+)?$/;
      if (row.claimCurrent){
        if (!regex.test(row.claimCurrent)){
          this.$alert("录入金额有误，请重新录入", '提示', {
            confirmButtonText: '确定',
            type:'error',
          });
          for (let i = 0; i < this.ttdata.length; i++) {
            if (row.belnr == this.ttdata[i].belnr){
              //录入金额有问题，清除
              this.ttdata[i].claimCurrent = '';
              break
            }
          }
          return
        }
        if (row.claimCurrent > row.surplusWrbtr){
          //如果认领金额大于剩余金额，清除
          this.$alert("认领金额大于剩余金额，请重新录入", '提示', {
            confirmButtonText: '确定',
            type:'error',
          });
          for (let i = 0; i < this.ttdata.length; i++) {
            if (row.belnr == this.ttdata[i].belnr){
              //录入金额有问题，清除
              this.ttdata[i].claimCurrent = '';
              break
            }
          }
          return
        }
        let claimCurrent = 0;
        for (let i = 0; i < this.ttdata.length; i++) {
          if (null != this.ttdata[i].claimCurrent && '' != this.ttdata[i].claimCurrent && undefined != this.ttdata[i].claimCurrent){
            claimCurrent += Number(this.ttdata[i].claimCurrent);
          }
        }
        claimCurrent = claimCurrent + Number(this.sapCodeCopy.claimWrbtrs);
        if (claimCurrent > Number(this.sapCodeCopy.totalprice)){
          this.$alert("认领总金额大于订单金额，请重新录入", '提示', {
            confirmButtonText: '确定',
            type:'error',
          });
          for (let i = 0; i < this.ttdata.length; i++) {
            if (row.belnr == this.ttdata[i].belnr){
              //录入金额有问题，清除
              this.ttdata[i].claimCurrent = '';
              break
            }
          }
          return
        }
        console.log(this.sapCodeCopy)
      }
    },
    //批量安排发货
    sendAll() {
      if (this.multipleSelection.length == 0){
        this.$alert("请勾选产品订单", '提示', {
          confirmButtonText: '确定',
          type:'error',
        });
        return;
      }
      if(this.fahuoFlag){
        this.$msg.confirm("确认批量发货?", () => {
          this.fahuoFlag = false;
          var sapIds = [];
          this.multipleSelection.forEach(element => {
            sapIds.push(element.sapCode);
          });
          this.sapCodes = sapIds;
          ss.OrderMainService.confirmSendAll(this.sapCodes).then(rd => {
            this.$msg.msgs(rd.msg);
            this.query();
            this.fahuoFlag = true;
          });
        })
      }else{
        this.$msg.error("不能执行重复发货，请刷新页面重新加载！");
      }
    },
    createInvoice () {
      console.log(this.multipleSelection)
      let flag = true;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        //如果不是退货订单并且
        //判断是不是天满的产品
        //天满产品放开发货通知单打印闸口，先放开闸口，采购节点不变
        if ('14' != this.multipleSelection[i].orderCategory1 && this.multipleSelection[i].sapCode.indexOf("-") == -1){
          if (50 != this.multipleSelection[i].status && 60 != this.multipleSelection[i].status  && 100 != this.multipleSelection[i].status
          && !this.multipleSelection[i].productHierarchy.includes("YX1E33") && !this.multipleSelection[i].productHierarchy.includes("YX1J26") && !this.multipleSelection[i].productHierarchy.includes("YX1J27")
          ){
            this.$msg.msge(this.multipleSelection[i].sapCode + "订单未安排发货，无法生成发货通知单");
            return;
          }
        }else {
          flag = false;
        }
      }
      ss.OrderMainService.createInvoice(this.multipleSelection).then(res => {
        this.query();
        const link = document.createElement('a')
        let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        if (flag){
          link.setAttribute('download', `发货通知单.xlsx`)
        }else {
          link.setAttribute('download', `退货通知单.xlsx`)
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      });
    },
    mergeFile () {
      if (this.multipleSelection.length > 0) {
        let arr = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          arr.push(this.multipleSelection[i].sapCode)
        }
        ss.OrderMainService.supplementlaterChange(arr).then(rd => {
          console.log(rd);
          if (rd.f) {
            ss.OrderMainService.supplementlater(arr).then(rd => {
              const blob = new Blob([rd], { type: 'application/pdf' })
              this.pdfUrl = URL.createObjectURL(blob)
              this.lookPdfflag = true;
            })
          }
        }).catch(error => {

        });
      } else {
        this.$alert('请选择订单信息！', '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
        });
      }
    },
    createInvoicepdf () {
      console.log(this.multipleSelection)
      let flag = true;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        //如果不是退货订单并且
        //判断是不是天满的产品
        //天满产品放开发货通知单打印闸口，先放开闸口，采购节点不变
        if ('14' != this.multipleSelection[i].orderCategory1 && this.multipleSelection[i].sapCode.indexOf("-") == -1){
          if (50 != this.multipleSelection[i].status && 60 != this.multipleSelection[i].status  && 100 != this.multipleSelection[i].status
                  && !this.multipleSelection[i].productHierarchy.includes("YX1E33") && !this.multipleSelection[i].productHierarchy.includes("YX1J26") && !this.multipleSelection[i].productHierarchy.includes("YX1J27")
          ){
            this.$msg.msge(this.multipleSelection[i].sapCode + "订单未安排发货，无法生成发货通知单");
            return;
          }
        }else {
          flag = false;
        }
      }
      ss.OrderMainService.createInvoicePdf(this.multipleSelection).then(res => {
        const blob = new Blob([res], { type: 'application/pdf' })
        this.pdfUrl = URL.createObjectURL(blob)
        this.lookPdfflag = true;
        this.query();
      });
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '合同编码' || column.label == '订货单位名称' || column.label == '总金额' || column.label == '业务归属'
          || column.label == '已认领总金额' || column.label == '操作' || column.label ==  '订单创建人'){
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    getSpanArr () {
      this.spanArr = [];
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].contractNo === this.tableData[index - 1].contractNo) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      })
    },
    //勾选事件
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    formatDatecc (row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if (data == null || data == '') {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
    //导出
    exportExcel () {
      updownfile.down("/api/swyl/v1/product/exportViewContractYxList", this.formInline, "post", 'sata');
    },
  },
}
</script>
<style scoped lang="scss">
</style>
<style>
.dialog-chengprice .el-dialog {
  border-radius: 0.1rem;
  width: 12.89rem !important;
}
</style>